import React from 'react';
import { CampaignDeliveryStepStatus } from '../../../../support/campaigns';
import { useFetchDeliveryStepStatuses } from '../../../../hooks/campaign-hooks';

/**
 * A headless (renders nothing) loader for one delivery's step statuses. Fanning these out — one loader
 * component per delivery — is how a campaign-wide, per-step rollup is assembled while respecting the
 * rules of hooks (a hook cannot be called in a loop): each delivery gets its own component, hence its
 * own `useFetchDeliveryStepStatuses` call, and reports its rows up to the panel that aggregates them.
 */
const DeliveryStepStatusLoader: React.FC<{
  deliveryId: number;
  onLoad: (deliveryId: number, rows: CampaignDeliveryStepStatus[]) => void;
}> = ({ deliveryId, onLoad }) => {
  const { data } = useFetchDeliveryStepStatuses(deliveryId);
  React.useEffect(() => {
    if (data) onLoad(deliveryId, data);
  }, [data, deliveryId, onLoad]);
  return null;
};

export default DeliveryStepStatusLoader;
